module.exports = __webpack_public_path__ + "static/media/greenhouse3-09.1c84d4a7.webp";